import { parseInt } from 'lodash';
import { adminClient as apolloClient } from '@/store/apollo';

import OrderNotificationRulesGql from '@/extensions/communication/store/graphql/queries/OrderNotificationRules.gql';
import SaveOrderNotificationRuleGql from '@/extensions/communication/store/graphql/mutations/SaveOrderNotificationRule.gql';
import DeleteOrderNotificationRuleGql from '@/extensions/communication/store/graphql/mutations/DeleteOrderNotificationRule.gql';

export default {
    fetchList: cmsID =>
        new Promise((resolve, reject) => {
            apolloClient
                .query({ query: OrderNotificationRulesGql, variables: { cms_id: parseInt(cmsID) }, fetchPolicy: 'network-only' })
                .then(({ data }) => resolve(data.EX_COMM_OrderNotificationRules))
                .catch(err => reject(err));
        }),

    save: (cmsID, rule) =>
        new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: SaveOrderNotificationRuleGql,
                    variables: {
                        cms_id: parseInt(cmsID),
                        event: rule.event,
                        channels: rule.channels || [],
                        template_name: rule.template_name || null,
                        template_name_without_tracking: rule.template_name_without_tracking || null,
                        template_variables: rule.template_variables || [],
                        buttonVariableKeys: (rule.buttonVariableKeys || []).map(pair => ({
                            key: String(pair.key),
                            value: pair.value
                        })),
                        fallback_hours: parseInt(rule.fallback_hours) || 0,
                        enabled: !!rule.enabled
                    }
                })
                .then(async ({ data }) => {
                    await apolloClient.clearStore();
                    resolve(data.EX_COMM_SaveOrderNotificationRule);
                })
                .catch(err => reject(err));
        }),

    remove: (cmsID, event) =>
        new Promise((resolve, reject) => {
            apolloClient
                .mutate({ mutation: DeleteOrderNotificationRuleGql, variables: { cms_id: parseInt(cmsID), event } })
                .then(async ({ data }) => {
                    await apolloClient.clearStore();
                    resolve(data.EX_COMM_DeleteOrderNotificationRule);
                })
                .catch(err => reject(err));
        })
};
